import { EDITOR_TOOLS, ProductTypes } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorTool } from '@editor/interfaces/editor'
import { UserInfo } from '@editor/interfaces/user'

import { CameraToolbar } from './components/CameraToolbar'
import useEditor from './hooks/useEditor'
import useMainCanvas from './hooks/useMainCanvas'

const CameraProfile: EditorTool = {
  key: EDITOR_TOOLS.CAMERA_PROFILE,
  cursor: CursorState.CROSSHAIR,
  authCheck: (userProfile: UserInfo | null) =>
    userProfile?.owned_products.includes(ProductTypes.Hatsuly) ||
    userProfile?.owned_products.includes(ProductTypes.Markly) ||
    false,
  components: {
    editor: [CameraToolbar],
  },
  hooks: {
    useEditor,
    useMainCanvas,
  },
  config: {
    anchor: {
      notPlaceableOnObjects: true,
    },
    dependencies: [EDITOR_TOOLS.CAMERA_PROFILE],
  },
}

export default CameraProfile
